import { AppEnvironment, FirebaseEnvironment, StoreURL } from './entities/app_envirinment'

const firebase: FirebaseEnvironment = {
    apiKey: "AIzaSyCqANKPpKp30Vr5h9NHR_MtGL_LX5aybTo",
    authDomain: "mc-app-tonkatsu-dev.firebaseapp.com",
    projectId: "mc-app-tonkatsu-dev",
    storageBucket: "mc-app-tonkatsu-dev.firebasestorage.app",
    messagingSenderId: "111908980788",
    appId: "1:111908980788:web:6eac121f3a8674e924a261",
    measurementId: "G-GTML7V9YDP"
}

const storeURL: StoreURL = {
    ios: 'https://apps.apple.com/app/id{{Set Tonkatsu ID}}',
    android: 'https://play.google.com/store/apps/details?id=jp.rosudo.members',
}

export const environment: AppEnvironment = {
    production: false,
    brandCode: 'tonkatsu',
    env: 'dev',
    firebase,
    hostingBaseURL: 'https://app-dev.rosudo.jp',
    appScheme: 'tonkatsu-monogatari-app-dev',
    storeURL,
}
